import { render, staticRenderFns } from "./CovidRecirc.vue?vue&type=template&id=63de5e8c&"
import script from "./CovidRecirc.vue?vue&type=script&lang=js&"
export * from "./CovidRecirc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports